import { ReactNode } from 'react';
import styles from './TabPanel.module.css';

/**
 * Props para TabPanel
 */
export interface TabPanelProps {
    /** ID del tab */
    tabId: string;
    /** Si este panel está actualmente activo */
    isActive: boolean;
    /** Contenido del panel */
    children: ReactNode;
}

/**
 * TabPanel - Panel individual de un tab
 * 
 * Responsabilidades:
 * - Mantener montado el contenido del tab (preservar estado)
 * - Controlar visibilidad con CSS (display: none cuando inactivo)
 * - Accessor ARIA para accesibilidad
 * 
 * Arquitectura:
 * - Componente de presentación puro
 * - No maneja estado, solo recibe props
 * - Separación clara de responsabilidades
 */
export const TabPanel = ({ tabId, isActive, children }: TabPanelProps) => {
    return (
        <div
            className={styles.tabPanel}
            style={{ display: isActive ? 'block' : 'none' }}
            role="tabpanel"
            aria-labelledby={`tab-${tabId}`}
            aria-hidden={!isActive}
        >
            {children}
        </div>
    );
};
